<template>
    <aside class="left_bar">
        <router-link class="brand" to="/index">
            <span class="brand-mark" aria-hidden="true"></span>
            <span class="brand-copy"><strong>绿数花旅</strong><small>FLOWER &amp; LANDSCAPE</small></span>
        </router-link>
        <div class="school-wrap">
            <el-select
                v-model="tenantId"
                placeholder="请选择院校"
                @change="verChange"
            >
                <el-option
                    v-for="item in list"
                    :key="item.organizationId"
                    :label="item.organizationName"
                    :value="item.organizationId"
                ></el-option>
            </el-select>
        </div>
        <nav class="menu_list" aria-label="主菜单">
            <div class="menu-group" v-for="(item, index) in routers" :key="index">
                <div class="menu-label">{{ item.label }}</div>
                <template v-for="(sitem, sindex) in item.secRouters">
                    <template v-if="!(!isTeacher && sitem.isTeacherOnly)">
                        <a
                            v-if="sitem.external"
                            :key="sindex"
                            class="menu-item"
                            :href="sitem.path"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i class="iconfont" :class="{ [sitem.icon]: true }" />
                            <span>{{ sitem.name }}</span>
                        </a>
                        <router-link
                            class="menu-item"
                            :to="sitem.path"
                            :key="sindex"
                            v-else-if="!sitem.future"
                        >
                            <i
                                class="iconfont"
                                :class="{ [sitem.icon]: true }"
                            />
                            <span>{{ sitem.name }}</span>
                        </router-link>
                        <template v-else>
                            <div class="menu-item" :key="sindex">
                                <i
                                    class="iconfont"
                                    :class="{ [sitem.icon]: true }"
                                />
                                <span>{{ sitem.name }}</span>
                            </div>
                        </template>
                    </template>
                </template>
            </div>
        </nav>
    </aside>
</template>

<script>
export default {
    data() {
        return {
            list: [],
            tenantId: "",
            routers: [
                {
                    label: "教学工作台",
                    secRouters: [
                        {
                            path: "/index",
                            name: "后台首页",
                            icon: "icon-a-xianxing_anquanbaozhangfuben58",
                        },
                        {
                            path: "/race",
                            name: "插花比赛",
                            icon: "icon-a-xianxing_anquanbaozhangfuben",
                        },
                        {
                            path: "/homework",
                            name: "插花作业",
                            icon: "icon-a-xianxing_anquanbaozhangfuben24",
                        },
                        {
                            path: "/courseware",
                            name: "教学课件",
                            icon: "icon-a-xianxing_anquanbaozhangfuben25",
                        },
                    ],
                },
                {
                    label: "创作中心",
                    secRouters: [
                        {
                            path: "/work",
                            name: "我的作品",
                            icon: "icon-a-xianxing_anquanbaozhangfuben27",
                        },
                        {
                            path: "/templateFlower",
                            name: "模板创作",
                            icon: "icon-a-xianxing_anquanbaozhangfuben25",
                        },
                        {
                            path: "/ai3d",
                            name: "AI 3D 生成",
                            icon: "icon-a-xianxing_anquanbaozhangfuben54",
                        },
                        {
                            path: "/ai-chat",
                            name: "AI 对话",
                            icon: "icon-a-xianxing_anquanbaozhangfuben27",
                        },
                    ],
                },
                {
                    label: "人员与素材",
                    secRouters: [
                        {
                            path: "/manage",
                            name: "学生管理",
                            icon: "icon-xianxing-08",
                            isTeacherOnly: true,
                        },
                        {
                            path: "/materials",
                            name: "素材库管理",
                            icon: "icon-a-xianxing_anquanbaozhangfuben54",
                            isTeacherOnly: true,
                        },
                    ],
                },
                {
                    label: "数据与设置",
                    secRouters: [
                        {
                            path: "/teachingData",
                            name: "教学数据",
                            icon: "icon-xianxing_anquanbaozhang",
                            isTeacherOnly: true,
                        },
                        {
                            path: "/account",
                            name: "账号管理",
                            icon: "icon-xianxing-14",
                        },
                    ],
                },
            ],

            currentSchool: {},
        };
    },
    mounted() {
        this.$ajax.post("user/user/getOrganizationList").then(res => {
            res = res.data;
            let cur =
                res.find(item => {
                    return item.isCurrent == 1;
                }) || {};

            localStorage.setItem("currentSchool", JSON.stringify(cur));
            this.currentSchool = cur;
            this.tenantId = cur ? cur.organizationId : "";
            this.list = res;
        });
    },
    methods: {
        verChange(id) {
            this.$ajax
                .post("/user/user/changeOrganization", {
                    organizationId: id,
                })
                .then(res => {
                    this.$message({
                        message: "切换成功",
                        type: "success",
                    });
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 500);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.left_bar {
    position: fixed;
    inset: 0 auto 0 0;
    z-index: 30;
    display: flex;
    flex-direction: column;
    width: 246px;
    border-right: 1px solid #e8eee9;
    background: #fff;
    .brand {
        height: 88px;
        padding: 0 24px;
        display: flex;
        align-items: center;
        gap: 12px;
        color: #18201c;
        text-decoration: none;
        border-bottom: 1px solid #e8eee9;
    }
    .brand-mark {
        position: relative;
        width: 42px;
        height: 42px;
        flex: 0 0 auto;
        border-radius: 13px;
        background: linear-gradient(145deg, #42c77e, #188b50);
        box-shadow: 0 8px 20px rgba(33, 150, 91, .22);
        &::before, &::after {
            content: "";
            position: absolute;
            background: #fff;
            border-radius: 100% 0 100% 0;
            transform: rotate(-34deg);
        }
        &::before { width: 20px; height: 12px; left: 8px; top: 10px; }
        &::after { width: 17px; height: 10px; right: 6px; bottom: 9px; opacity: .78; }
    }
    .brand-copy strong { display: block; font-size: 19px; letter-spacing: .04em; }
    .brand-copy small { display: block; margin-top: 3px; color: #89948d; font-size: 10px; letter-spacing: .12em; }
    .school-wrap { padding: 18px 18px 8px; }
    .menu_list { flex: 1; overflow-y: auto; padding: 10px 14px 20px; }
    .menu-group + .menu-group { margin-top: 19px; padding-top: 17px; border-top: 1px solid #e8eee9; }
    .menu-label { padding: 0 12px 8px; color: #a0aaa4; font-size: 12px; font-weight: 700; letter-spacing: .08em; }
    .menu-item {
        min-height: 43px;
        display: flex;
        align-items: center;
        gap: 11px;
        margin: 3px 0;
        padding: 0 13px;
        border-radius: 12px;
        color: #59645e;
        font-size: 14px;
        text-decoration: none;
        transition: .18s ease;
        .iconfont { width: 21px; font-size: 20px; text-align: center; }
        &:hover { color: #21965b; background: #f4fbf7; }
        &.router-link-active { color: #21965b; background: #eaf8f0; font-weight: 650; }
    }
}
@media (max-width: 900px) {
    .left_bar { width: 72px; }
    .brand { justify-content: center; padding: 0 !important; }
    .brand-copy, .school-wrap, .menu-label, .menu-item span { display: none !important; }
    .menu_list { padding: 12px !important; }
    .menu-item { justify-content: center; padding: 0; }
}
@media (max-width: 640px) {
    .left_bar { display: none; }
}
</style>
